'use client'
import { __awaiter } from '../../_virtual/_tslib.js';
import { logger } from '@dynamic-labs/wallet-connector-core';

const getNameservice = (_a) => __awaiter(void 0, [_a], void 0, function* ({ rpcProvider, address, }) {
    var _b;
    const nsData = {
        avatar: undefined,
        name: undefined,
    };
    const network = yield rpcProvider.getChainId();
    if (!network) {
        return nsData;
    }
    // Handle Base name service requests
    if (network === 8453) {
        try {
            const response = yield fetch(`https://resolver-api.basename.app/v1/addresses/${address}`);
            if (response.ok) {
                const data = yield response.json();
                nsData.name = (_b = data.name) !== null && _b !== void 0 ? _b : undefined;
            }
        }
        catch (e) {
            logger.debug('Failed to fetch ens data', e);
        }
        return nsData;
    }
    else {
        nsData.name = (yield rpcProvider.getEnsName({
            address: address,
        }));
        nsData.avatar = nsData.name
            ? (yield rpcProvider.getEnsAvatar({
                name: nsData.name,
            }))
            : undefined;
    }
    return nsData;
});

export { getNameservice };
